import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { AgentsComponent } from './agents/agents.component';
import { BlogComponent } from './blog/blog.component';
import { BlogSingleComponent } from './blog-single/blog-single.component';
import { ContactComponent } from './contact/contact.component';
import { PropertiesComponent } from './properties/properties.component';
import { PropertiesSingleComponent } from './properties-single/properties-single.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { SupportComponent } from './support/support.component';
import { SignupComponent } from './signup/signup.component';
import { CreatePropertyComponent } from './create-property/create-property.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ProfileviewComponent } from './profileview/profileview.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { SearchPropertyListComponent } from './search-property-list/search-property-list.component';
import { CommonPropertyComponent } from './common-property/common-property.component';
import { LoginComponent } from './login/login.component';
import { FavouriteListComponent } from './favourite-list/favourite-list.component';
import { InquiryListComponent } from './inquiry-list/inquiry-list.component';
import { PropertyViewComponent } from './property-view/property-view.component';
import { GallaryOfImageComponent } from './gallary-of-image/gallary-of-image.component';
import { FeaturedPropertiesComponent } from './featured-properties/featured-properties.component';
import { ExampleSwiperComponent } from './example-swiper/example-swiper.component';
import { AuthGuardService } from './service/auth-guard.service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PropertieViewComponent } from './propertie-view/propertie-view.component';
import { ContactUsModelComponent } from './contact-us-model/contact-us-model.component';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { SubscriptionOwnerPlanComponent } from './subscription-owner-plan/subscription-owner-plan.component';
import { SubscriptionSellerPlanComponent } from './subscription-seller-plan/subscription-seller-plan.component';
import { SubscriptionBuyerPlanComponent } from './subscription-buyer-plan/subscription-buyer-plan.component';
import { SignupModalComponent } from './signup-modal/signup-modal.component';
import { SubscriptionTenantPlanComponent } from './subscription-tenant-plan/subscription-tenant-plan.component';
import { NewFeaturedPropertiesComponent } from './new-featured-properties/new-featured-properties.component';
import { PaymentStatusPageComponent } from './payment-status-page/payment-status-page.component';
import { FaqComponent } from './faq/faq.component';
import { CareersComponent } from './careers/careers.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { DisclamersComponent } from './disclamers/disclamers.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { PaymentTermsAndConditionsComponent } from './payment-terms-and-conditions/payment-terms-and-conditions.component';
import { PaymentListComponent } from './payment-list/payment-list.component';
import { InvoiceListComponent } from './invoice-list/invoice-list.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { ContactedPropertiesComponent } from './contacted-properties/contacted-properties.component';
import { PaymentCouponComponent } from './payment-coupon/payment-coupon.component';
import { DeveloperViewComponent } from './developer-view/developer-view.component';
import { DeveloperComponent } from './developer/developer.component';
import { DirektVirtualTourComponent } from './direkt-virtual-tour/direkt-virtual-tour.component';
import { ReviewsViewComponent } from './reviews-view/reviews-view.component';
import { NewPropertyListComponent } from './new-property-list/new-property-list.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuardService] },
  { path: 'about', component: AboutComponent },
  { path: 'agents', component: AgentsComponent },
  { path: 'blog', component: BlogComponent },
  { path: 'blog-single', component: BlogSingleComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'properties', component: PropertiesComponent },
  { path: 'properties/:sell_type', component: SearchPropertyListComponent },
  { path: 'properties/city/:city', component: SearchPropertyListComponent },
  { path: 'properties/type/:type', component: SearchPropertyListComponent },
  { path: 'properties/no_of_bedrooms/:no_of_bedrooms', component: SearchPropertyListComponent },
  { path: 'my-property-list', component: SearchPropertyListComponent },
  { path: 'properties-single', component: PropertiesSingleComponent },
  { path: 'terms-of-use', component: TermsConditionsComponent },
  { path: 'support', component: SupportComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'create-property', component: CreatePropertyComponent, canActivate: [AuthGuardService] },
  { path: 'update-property/:id', component: CreatePropertyComponent, canActivate: [AuthGuardService] },
  { path: 'forgot-password', component: ForgotpasswordComponent },
  { path: 'reset-password', component: ResetpasswordComponent, },
  { path: 'profile-view', component: ProfileviewComponent },
  { path: 'search', component: SearchPropertyListComponent },
  { path: 'common-property', component: CommonPropertyComponent },
  // { path: 'login', component: LoginComponent },
  { path: 'favourite-list', component: FavouriteListComponent, canActivate: [AuthGuardService] },
  { path: 'inquiry-list', component: InquiryListComponent, canActivate: [AuthGuardService] },
  { path: 'property-view', component: PropertyViewComponent },
  { path: 'gallary-of_iamges', component: GallaryOfImageComponent },
  { path: 'featured', component: FeaturedPropertiesComponent },
  { path: 'example-swiper', component: ExampleSwiperComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  { path: 'property', component: PropertieViewComponent },
  { path: 'view-property/:id', component: PropertieViewComponent },
  { path: 'view-property/:id/:property-name', component: PropertieViewComponent },
  { path: 'contact-us', component: ContactUsModelComponent },
  { path: 'subscription-owner-plan', component: SubscriptionOwnerPlanComponent},
  { path: 'subscription-buyer-plan', component: SubscriptionOwnerPlanComponent},
  { path: 'subscription-tenant-plan', component: SubscriptionOwnerPlanComponent},
  { path: 'signup-modal', component: SignupModalComponent },
  { path: 'signup-modal', component: SignupModalComponent },
  { path: 'new-featured', component: NewFeaturedPropertiesComponent },
  { path: 'payment-status', component: PaymentStatusPageComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'careers', component: CareersComponent },
  { path: 'cookie-policy', component: CookiePolicyComponent },
  { path: 'set-password', component: SetPasswordComponent },
  { path: 'disclaimers', component: DisclamersComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'delete-account', component: DeleteAccountComponent },
  { path: 'payment-terms-and-conditions', component: PaymentTermsAndConditionsComponent },
  { path: 'payment-list', component: PaymentListComponent },
  // { path: 'invoice-list', component: InvoiceListComponent },
  // { path: 'invoice', component: InvoiceComponent },
  { path: 'subscription-list', component: SubscriptionComponent },
  { path: 'contacted-properties', component: ContactedPropertiesComponent, canActivate: [AuthGuardService]  },
  { path: 'oauth/:token', component: LoginComponent },
  { path: 'payment-coupon', component: PaymentCouponComponent },
  { path: 'developer-view/:id', component: DeveloperViewComponent },
  { path: 'developer-view/:id/:developer-name', component: DeveloperViewComponent },
  { path: 'developer', component: DeveloperComponent },
  { path: 'virtual-tour', component: DirektVirtualTourComponent },
  { path: 'reviews-view/:id', component: ReviewsViewComponent },
  { path: 'new-property', component: NewPropertyListComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
